import CoreForm from './CoreForm';

export { type CoreFormProps } from './CoreForm';
export default CoreForm;
